const r = document.querySelector(':root');
const footer = document.querySelector("#site-footer");
const contactCard = document.querySelector("section.contact-card");
const contactCardToggle = contactCard.querySelector(".up-arrow");
let toggleState = 0;
let footerOpen = 0;

if (document.body.classList.contains("form-open")) {
    footer.classList.add("card-open");
    footerOpen = 1;
}

contactCardToggle.addEventListener("click", function() {

    if (toggleState === 0) {
        footer.classList.add("card-open");

        bodyScrollLock.disableBodyScroll(contactCard, {
            reserveScrollBarGap: true
        });

        r.classList.add("lock-scroll");

        toggleState = 1;
    }
    else {
        footer.classList.remove("card-open");
        // bodyScrollLock.enableBodyScroll(contactCard);
        bodyScrollLock.clearAllBodyScrollLocks();
        toggleState = 0;
        r.classList.remove("lock-scroll");
    }



    if (document.body.classList.contains("form-open")) {
        document.body.classList.remove("form-open");

    }



});

